@if (!loading) {
  <app-patient-header [patient]="patient" />
  <div class="page-container">
    <div class="mt-3">
      <div class="card">
        <div class="card-body">
          <h5 class="mb-4">Patient Encounters</h5>
          <app-encounter-list
            [fetchEncounters]="fetchPatientEncounters"
            [eligibleCount]="patient.eligibleEncountersCount"
            [ineligibleCount]="patient.ineligibleEncountersCount"
            />
        </div>
      </div>
    </div>
  </div>
} @else {
  <mat-spinner />
}

